<template>
    <div v-show="visible">
        <el-dialog title="新增" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="65%">    
            <el-form ref="form" :model="form" :rules="rules"  label-width="85px">
                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">基本信息：</div>    
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="name" label="姓名">
                            <el-input v-model="form.name" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="personType" label="人员类型">
                            <el-select v-model="form.personType"  clearable placeholder="请选择" @change="personSelect">
                                <el-option
                                    v-for="item in personTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="deptId" label="所属机构">
                            <el-cascader
                                :options="depts"
                                v-model="form.deptId"
                                :props="props"
                                @change="onDeptChange"
                                collapse-tags
                                clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="roleId" label="角色">
                              <el-cascader
                                :options="roles"
                                v-model="form.roleId"
                                :props="props"
                                collapse-tags
                                clearable></el-cascader>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="sex" label="性别">
                            <el-select v-model="form.sex"  clearable placeholder="请选择">
                                <el-option
                                    v-for="item in sexs"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="identityCard" label="身份证">
                            <el-input v-model="form.identityCard" maxlength="50" placeholder="不填写，默认自动生成"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="status" label="岗位状态">
                            <el-select v-model="form.status"  clearable placeholder="请选择">
                                <el-option
                                    v-for="item in statuss"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="postId" label="岗位">
                            <el-select v-model="form.postId" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in posts"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="postDescrible" label="职责描述">
                             <el-input v-model="form.postDescrible" maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">                   
                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="studentType" label="学生类型" v-if="form.personType == 1">
                            <el-select v-model="form.studentType"  clearable placeholder="请选择">
                                <el-option
                                    v-for="item in studentTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="roomNumber" label="宿舍房间号" v-if="form.studentType == 1">
                             <el-input v-model="form.roomNumber" maxlength="200"></el-input>
                        </el-form-item>
                    </el-col>

                     <el-col :lg="8" :xl="11">
                        <el-form-item prop="office" label="办公室地点">
                            <el-input v-model="form.office" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="15">
                    
                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="expertise" label="有何专长">
                            <el-input v-model="form.expertise" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="hobby" label="爱好">
                             <el-input v-model="form.hobby" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="graduationDate" label="毕业年月">
                            <el-input v-model="form.graduationDate" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="15">

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="graduationSchool" label="毕业学校">
                            <el-input v-model="form.graduationSchool" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="classNo" label="班内学号">
                            <el-input v-model="form.classNo" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :lg="8" :xl="11">
                         <el-form-item   prop="studentId" label="学籍辅号">
                            <el-input v-model="form.studentId" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="15">

                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="orderNum" label="排序号">
                            <el-input v-model="form.orderNum" maxlength="10" type="number" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>    
                
                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">通讯信息：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="mobile1" label="移动电话">
                             <el-input v-model="form.mobile1" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :lg="8" :xl="11">
                        <el-form-item prop="mobile2" label="办公室电话">
                            <el-input v-model="form.mobile2" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="11">
                        <el-form-item   prop="email" label="邮箱">
                            <el-input v-model="form.email" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--<div style="font-size:14px;margin-bottom:10px;font-weight:bold;">上下级关系：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="11">
                        <el-form-item prop="directSuperiors" label="直接上级">
                            <el-input placeholder="请选择人名" :readonly="true" v-model="form.directSuperiorsLabel" class="input-with-select">
                                <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="save()">确定</el-button>
            </span>    
        </el-dialog>

         <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from './UserTransfer.vue';

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                transferVisible:false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                roles:[],
                posts:[],
                personTypes:[{
                    value: 1,
                    label: '学生'
                }, {
                    value: 2,
                    label: '教职'
                }],
                sexs:[{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                statuss:[{
                    value: 1,
                    label: '正式'
                }, {
                    value: 2,
                    label: '试用'
                }, {
                    value: 3,
                    label: '临时'
                }],
                studentTypes:[{
                    value: 1,
                    label: '寄宿生'
                }, {
                    value: 2,
                    label: '走读生'
                }, {
                    value: 3,
                    label: '寄午生'
                }, {
                    value: 4,
                    label: '艺考生'
                }, {
                    value: 5,
                    label: '休假生'
                }, {
                    value: 0,
                    label: '其他'
                }],
                form:{
                    username:"",
                    studentId:"",
                    name:"",
                    postId:"",
                    personType:"",
                    roleId:"",
                    deptId:"",
                    // teachClass:"",
                    sex:"",
                    identityCard:"",
                    status:"",
                    classNo:"",
                    studentType:"",
                    roomNumber:"",
                    postDescrible:"",
                    office:"",
                    expertise:"",
                    hobby:"",
                    graduationDate:"",
                    graduationSchool:"",
                    orderNum:"1",
                    mobile1:"",
                    mobile2:"",
                    email:"",
                    directSuperiors:"",
                    directSuperiorsLabel:""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    personType: [
                        { required: true, message: '请选择人员类型', trigger: 'blur' }
                    ],
                    deptId: [
                        {type: 'array', required: true, message: '请选择机构', trigger: 'blur' }
                    ],
                    // sex: [
                    //     { required: true, message: '请选择性别', trigger: 'blur' }
                    // ],
                    mobile1:[
                        { validator: this.checkPhone, trigger: 'blur' }
                    ],
                    email:[
                        { type: 'email', message: '邮箱地址格式有误', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            userTransfer
        },
        created:function () {
            this.getDeptCascader();
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId = '';
                this.form.directSuperiors='';
                this.form.directSuperiorsLabel='';
            },
            personSelect(){
                // console.log(this.form.personType);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 身份证验证
            async validID(rule,value,callback){
                let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('身份证号码不正确'))
                }
            },
            // 手机号验证
            async checkPhone(rule,value,callback){
                let phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]{9}$/
                if(this.$util.isEmpty(value)){
                    callback();
                    return;
                }
                if (phoneReg.test(value)) {
		          callback()
		        } else {
		          callback(new Error('移动电话格式不正确'))
		        }
                
            },
            //部门
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data.selects; 
                    // console.log("部门列表:"+JSON.stringify(this.depts))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            onDeptChange(){
                // 选中的部门变，更新角色与岗位
                this.getRoles();
                this.getPosts();
            },
            //获取角色
            getRoles(){
                let url  = this.getRoleCascaderUrl;
                let data = {
                    'deptId':this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("角色列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.roles = res.data.selects; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //岗位
            getPosts(){
                let url  = this.listPostUrl;
                let data = {
                    'deptId':this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("岗位列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.posts = res.data.posts; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    let roleId = this.filterCascader(this.form.roleId);
                    let deptId = this.filterCascader(this.form.deptId);
                    // let teachClass = this.filterCascader(this.form.teachClass);
                    if(valid){
                        this.loading=true;
                        // 根据人员类型展示学生信息
                        if(this.form.personType == 2){
                            this.form.studentType="";
                            this.form.roomNumber="";
                        }else{
                            if(this.form.studentType != 1){
                                this.form.roomNumber="";
                            }
                        }

                        let url= this.userAddUrl;
                        let data = {
                            name:this.form.name,
                            postId:this.form.postId,
                            personType:this.form.personType,
                            roleId:roleId,
                            deptIdstr:deptId,
                            sex:this.form.sex,
                            identityCard:this.form.identityCard,
                            status:this.form.status,
                            classNo:this.form.classNo,
                            studentType:this.form.studentType,
                            roomNumber:this.form.roomNumber,
                            postDescrible:this.form.postDescrible,
                            office:this.form.office,
                            expertise:this.form.expertise,
                            hobby:this.form.hobby,
                            graduationDate:this.form.graduationDate,
                            graduationSchool:this.form.graduationSchool,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                            mobile1:this.form.mobile1,
                            mobile2:this.form.mobile2,
                            email:this.form.email,
                            directSuperiors:this.form.directSuperiors
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array();
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1]);
                }
               return arrVal.join();
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => { 
                    if(this.$util.isNotEmpty(this.form.directSuperiorsLabel)){
                        let val=new Array();
                        val.push(this.form.directSuperiors);
                        this.$refs['userTransfer'].init(2,val,1,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,1,this.form.deptId);
                    }
                })
            },
            setUser(key,label){
                this.form.directSuperiors = key;
                this.form.directSuperiorsLabel = label;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/Add.vue